<template>
  <div class="time-clock" :style="{ width: config.chartWidth + 'px', height: config.chartHeight + 'px' }">
    <div class="time-clock-inner">
      <div class="time-clock-body" :style="clockFontStyle">
        <div class="time-clock-blocks">
          <template v-if="hasAnySegment">
            <span v-if="segmentYear" class="time-clock-block" :style="blockAlignStyle">{{ segmentYear }}</span>
            <span v-if="segmentMonthDay" class="time-clock-block" :style="blockAlignStyle">{{ segmentMonthDay }}</span>
            <span v-if="segmentTime" class="time-clock-block" :style="blockAlignStyle">{{ segmentTime }}</span>
          </template>
          <span v-else class="time-clock-block time-clock-block--full" :style="blockAlignStyle">{{ emptyText }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import { getFontFamilyCss } from '@/utils/chartTitlePresets'

export default {
  name: 'TimeClock',
  props: {
    config: {
      type: Object,
      required: true,
    },
    globalConfig: {
      type: Object,
      default: () => ({}),
    },
    componentType: {
      type: String,
      default: 'timeClock',
    },
  },
  data () {
    return {
      segmentYear: '',
      segmentMonthDay: '',
      segmentTime: '',
      clockTimer: null,
      emptyText: '--',
    }
  },
  computed: {
    /** 字号、颜色、字体等（不含对齐，对齐按块单独应用） */
    clockFontStyle () {
      const cs = this.config.chartSet?.chartStyle || {}
      const style = {
        fontSize: (cs.fontSize != null ? cs.fontSize : 28) + 'px',
        color: cs.color || '#fff',
        lineHeight: 1.25,
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        minHeight: 0,
      }
      const ff = getFontFamilyCss(cs.fontFamily)
      if (ff) style.fontFamily = ff
      return style
    },
    blockAlignStyle () {
      return { textAlign: this.config.chartSet?.chartStyle?.textAlign || 'center' }
    },
    hasAnySegment () {
      return !!(this.segmentYear || this.segmentMonthDay || this.segmentTime)
    },
  },
  watch: {
    'config.chartSet': {
      handler () {
        this.tick()
      },
      deep: true,
    },
  },
  created () {
    const cs = this.config.chartSet?.chartStyle
    if (cs) {
      if (cs.fontSize === undefined) this.$set(cs, 'fontSize', 28)
      if (cs.color === undefined) this.$set(cs, 'color', '#fff')
      if (cs.textAlign === undefined) this.$set(cs, 'textAlign', 'center')
    }
  },
  mounted () {
    this.tick()
    this.clockTimer = setInterval(this.tick, 1000)
  },
  beforeDestroy () {
    if (this.clockTimer) {
      clearInterval(this.clockTimer)
      this.clockTimer = null
    }
  },
  methods: {
    tick () {
      const { year, monthDay, time } = this.buildSegments(dayjs())
      this.segmentYear = year
      this.segmentMonthDay = monthDay
      this.segmentTime = time
    },
    /** 三块：年 | 月日 | 时分秒 */
    buildSegments (d) {
      const td = this.config.chartSet?.timeDisplay || {}
      const on = (key) => td[key] !== false

      let year = ''
      if (on('year')) year = d.format('YYYY年')

      let monthDay = ''
      if (on('month')) monthDay += d.format('MM月')
      if (on('day')) monthDay += d.format('DD日')

      const timeBits = []
      if (on('hour')) timeBits.push(d.format('HH'))
      if (on('minute')) timeBits.push(d.format('mm'))
      if (on('second')) timeBits.push(d.format('ss'))
      const time = timeBits.join(':')

      return { year, monthDay, time }
    },
  },
}
</script>

<style lang="scss" scoped>
.time-clock {
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  min-height: 0;
}
.time-clock-inner {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 0;
  padding: 0 12px;
}
.time-clock-body {
  box-sizing: border-box;
  min-height: 0;
}
.time-clock-blocks {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  flex: 1;
  min-height: 0;
  column-gap: clamp(4px, 2%, 24px);
}
.time-clock-block {
  min-width: 0;
  font-variant-numeric: tabular-nums;
  word-break: keep-all;
  white-space: nowrap;
  overflow: visible;
}
.time-clock-block--full {
  flex: 1 1 100%;
}
</style>
